const INGREDIENT_AUTOCHECK_TREE_HEIGHT = 750

export default INGREDIENT_AUTOCHECK_TREE_HEIGHT
